import React from 'react';
import { AlertTriangle } from 'lucide-react';

export default function SiteModeBanner() {
  return (
    <div
      className="sticky top-0 z-[80] w-full bg-red-600 text-white border-b border-red-700"
      data-testid="site-mode-dev-banner"
    >
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-center gap-2 text-sm font-semibold tracking-wide">
        <AlertTriangle className="w-4 h-4" />
        DEV MODE — Contact Owner / Administrator
      </div>
    </div>
  );
}
